export function isStringNullOrEmpty(str) {
  return str === null || str === "" || str === undefined;
}

export function isValidPartnerName(str) {
  return !isStringNullOrEmpty(str) && str !== "-";
}

export function validateMobile(mobile) {
  let regex = /^(01[0-46-9]-?\d{7,8}|01[1-9]-?\d{8}|0[3-9]-?\d{7,8})$/;

  return regex.test(mobile);
}

export function validateEmail(email) {
  let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return regex.test(email);
}

export function validateNumber(value, min = 0, max = 5) {
  // Rule 1: The value must not be empty or just whitespace.
  if (value === null || String(value).trim() === "") {
    return false;
  }

  // Rule 2: The value must be a valid integer string (no decimals or letters).
  const isIntegerString = /^\d+$/.test(String(value));
  if (!isIntegerString) {
    return false;
  }

  // Rule 3: The parsed number must be within the specified range.
  const num = parseInt(value, 10);
  return num >= min && num <= max;
}

/**
 * Checks if the number input can be updated in the state.
 * This is lenient: it allows an empty string so the user can delete the value.
 * It also ensures only digits are entered.
 */
export function canUpdateNumberField(value, max = 5) {
  // Allow an empty string for editing purposes
  if (value === "") {
    return true;
  }

  // Use a regular expression to ensure the value contains only digits
  const isOnlyDigits = /^\d+$/.test(value);
  if (!isOnlyDigits) {
    return false;
  }

  // Check if the number is within the max limit
  const num = parseInt(value, 10);
  return num <= max;
}

export function getStringWithDefault(str, defaultValue = "-") {
  if (isStringNullOrEmpty(str)) return defaultValue;
  else return str;
}

export function getStringFromBooleanWithDefault(
  boolValue,
  ifTrue = "Yes",
  ifFalse = "No"
) {
  if (boolValue !== undefined) {
    if (boolValue === true) return ifTrue;
    else return ifFalse;
  } else {
    return "-";
  }
}

export const formatToTwoDigits = (num) => {
  return num.toString().padStart(2, "0");
};

export function capitalizeFirstLetter(str) {
  if (!str || typeof str !== "string") {
    return "";
  }

  if (str.length > 1) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  } else {
    return str;
  }
}
